import { __assign, __awaiter, __generator } from "tslib";
import { HttpClient } from '@wix/http-client';
var getMenusUrl = function (orgId, locationId) {
    if (locationId) {
        return "https://api.wixrestaurants.com/v2/organizations/" + orgId + "/menu?locationId=" + locationId;
    }
    return "https://api.wixrestaurants.com/v2/organizations/" + orgId + "/defaultMenu";
};
export function getOrganizationMenu(orgId, locationId, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, httpClient.get(getMenusUrl(orgId, locationId))];
                case 1:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, __assign({ sections: [], items: [], chargesV2: [], locationId: locationId }, response.data)];
                    }
                    throw new Error(response.statusText);
            }
        });
    });
}
export function updateOrganizationMenu(orgId, menu, authorization, locationId, httpClient) {
    if (httpClient === void 0) { httpClient = new HttpClient(); }
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, httpClient.put("https://api.wixrestaurants.com/v2/organizations/" + orgId + "/menu" + (locationId ? "?locationId=" + locationId : ''), menu, {
                        headers: {
                            authorization: authorization,
                            'Content-Type': 'application/json',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, __assign({ sections: [], items: [], chargesV2: [], locationId: locationId }, response.data)];
                    }
                    throw new Error(response.statusText);
            }
        });
    });
}
//# sourceMappingURL=menu.js.map